exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.wrapper--pageform[data-v-5e1583bf] {\n  overflow: hidden;\n}\n.wrapper--pageform .ic-label[data-v-5e1583bf] {\n    float: left;\n    width: 30px;\n}\n.wrapper--pageform .ic-label img[data-v-5e1583bf] {\n      display: block;\n}\n.btn-link[data-v-5e1583bf] {\n  line-height: 50px;\n  font-size: 1.2em;\n}\n.btn-login-button[data-v-5e1583bf] {\n  width: 100%;\n}\n.btn-forgot[data-v-5e1583bf] {\n  font-size: 0.9em;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5e1583bf","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"includePaths":["/Users/noomz/Projects/Opendream/kadnud/kadnud-eef-app/src/css"],"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/PageRegisterForm.vue
// module id = 584
// module chunks = 1